export const SUBS = [
  { value: "bollette", label: "Bollette" },
  { value: "lavori", label: "Lavori" },
  { value: "ristorante", label: "Ristorante" },
  { value: "spese_generali", label: "Spese generali" },
];

export const FREQ = { una_tantum: "Puntuale", mensile: "Ricorrente mensile" };
export const EXTRA_SUGGESTIONS = ["Work permit", "Ramadan bonus", "Visto", "Assicurazione", "Bonus"];
export const CURRENCIES = ["EUR", "USD", "MVR"];
export const SYMBOL = { EUR: "€", USD: "$", MVR: "Rf" };

export const subLabel = (v) => SUBS.find((s) => s.value === v)?.label || v;

export const toEur = (amount, cur, rates) => {
  const a = Number(amount || 0);
  if (!cur || cur === "EUR") return a;
  const rate = rates[cur];
  return rate ? a / rate : a;
};

export const fmtOrig = (amt, cur) =>
  `${SYMBOL[cur] || ""} ${Number(amt || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
